import { useAppDispatch } from 'app/hooks';
import { setLocale } from 'features/intl/intlSlice';
import { Locale } from 'helpers/consts';
import { useEffect } from 'react';
import { useNavigate } from 'react-router';

type SetLocaleProps = {
  locale: Locale;
};
export default function SetLocale(props: SetLocaleProps) {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    async function setLoc() {
      dispatch(setLocale(props.locale));
      navigate('/');
    }
    setLoc();
  }, [dispatch, navigate, props.locale]);

  return <></>;
}
